import { useState } from "react";
import Button from "@/components/common/form/button";
import { IoMdAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import AddOnMap from "./addOnMapModal";
import { authServices } from "services/auth.services";
import { setNotAuthorizedAlertData } from "@/redux/actions/notAuthorizedAlert";
import { useDispatch } from "react-redux";
export default function ActionButtons(props) {
  const { type, show, setShow, label } = props;
  const [showBtn, setShowBtn] = useState(true);
  const { i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      <div className="flex items-center  gap-x-2">
        {showBtn && (
          <Button
            title={
              i18n.language === "en"
                ? "Add" + " " + label
                : "إضافة" + " " + label
            }
            className="flex items-center justify-center px-3 py-1 text-white rounded-md bg-main "
            click={() =>
              authServices.userValue.policy_data.asset.actions.includes?.(
                "create"
              )
                ? setShow(!show)
                : dispatch(
                    setNotAuthorizedAlertData({ key: "showModal", value: true })
                  )
            }
            icon={() => <IoMdAdd size="1.1rem" />}
          />
        )}
        <Button
          title={
            i18n.language === "en"
              ? "Add" + " " + label + " " + "(On Map)"
              : "إضافة" + " " + label + " " + "(على الخريطة)"
          }
          icon={() => <IoMdAdd size="1.1rem" />}
          className="flex items-center justify-center px-3 py-1 text-white rounded-md outline-none bg-main"
          click={() =>
            authServices.userValue.policy_data.asset.actions.includes?.(
              "create"
            )
              ? setShowModal(true)
              : dispatch(
                  setNotAuthorizedAlertData({ key: "showModal", value: true })
                )
          }
        />
      </div>
      <AddOnMap
        showModel={showModal}
        setShowModel={setShowModal}
        label={label}
        type={type}
      />
    </>
  );
}
